import { Link } from "react-router-dom";
import Services from "../Home/Services/Services.tsx";

const AboutPage = () => {
  return (
    <div className="az">
      <main className="az-wrap infoPage">
        <div className="crumbs">
          <Link to="/">Home</Link>
          <span>/</span>
          <span>About Us</span>
        </div>
        <h1>About Us</h1>
        <p className="lede">
          From heritage to innovation, Ayzen represents the harmony of
          traditional Pakistani craftsmanship and contemporary fashion. Every
          thread tells a story of quality, elegance, and cultural pride.
        </p>
        <section>
          <h2>Our Story</h2>
          <p>
            Founded with a vision to celebrate Pakistan's rich textile heritage,
            Ayzen emerged as a brand that understands the essence of authentic
            ethnic fashion. We believe that clothing is more than just fabric —
            it's an expression of identity, culture, and personal style. Our
            journey began with a simple idea: to create garments that honor
            traditional craftsmanship while meeting the demands of modern life.
            Every design reflects our commitment to excellence, from the initial
            sketch to the final stitch.
          </p>
        </section>
        <section>
          <h2>The Company</h2>
          <p>
            Launched in 2025, Ayzen is a Pakistan-based ethnic clothing brand
            rooted in heritage and driven by quality. We specialize in premium
            fabrics, timeless designs, and a seamless experience from beginning
            to end. We blend traditional aesthetics with contemporary
            silhouettes to create clothing that reflects elegance, comfort, and
            meticulous craftsmanship.
          </p>
          <p>
            Fabric quality is at the heart of what we do. We source fine
            textiles for softness, longevity, and a refined finish, whether for
            everyday wear or special occasions. From sizing consistency to
            finishing touches, every detail is inspected to uphold the standards
            that define Ayzen. Proudly made in Pakistan, each piece pays homage
            to cultural roots while embracing careful design. Ayzen — made to
            wear, to trust, and to keep.
          </p>
        </section>
      </main>
      <div className="az-wrap">
        <Services />
      </div>
    </div>
  );
};

export default AboutPage;
